import React from 'react';

export default function FileThumb({id, filename, title, onRemove})
{
    return (
        <div>
            <button className='button button-small' title="Remove this image" onClick={evt =>
            {
                evt.stopPropagation();
                evt.preventDefault();
                onRemove(evt, id);
            }}><i className='icon-cross'></i></button>
            <div><h4>{title}</h4></div>
            <code>[{title}]({filename})</code>
        </div>
    );
};